import Category from '@/models/Category';
import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { Categories, CategoriesState, CategoryTypes } from './types';

const INITIAL_STATE: CategoriesState = {
    data: {
        categories: [] as Category[],
        selectedCategories: [] as Category[],
        category: {} as Category,
        categoriesTotalCountOfRegisters: 0,
    } as Categories,
    loading: true,
    hasError: false,
    error: undefined,
};

const reducer: Reducer<CategoriesState> = (state: CategoriesState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case CategoryTypes.GET_CATEGORIES_REQUEST:
            return { ...state, loading: true };
        case CategoryTypes.GET_CATEGORIES_SUCCESS:
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    categories: action.payload.categories,
                    categoriesTotalCountOfRegisters: action.payload.categoriesTotalCountOfRegisters,
                },
            };
        case CategoryTypes.GET_CATEGORIES_FAILURE:
            return { ...state, loading: false, hasError: true, error: action.payload };
        case CategoryTypes.GET_CATEGORY_REQUEST:
            return { ...state, loading: true, hasError: false, error: undefined };
        case CategoryTypes.GET_CATEGORY_SUCCESS:
            return { ...state, loading: false, data: { ...state.data, category: action.payload } };
        case CategoryTypes.GET_CATEGORY_FAILURE:
            return { ...state, loading: false, hasError: true, error: action.payload };
        case CategoryTypes.GET_CATEGORY_CLEAR:
            return { ...state, data: { ...state.data, category: undefined }, loading: false, hasError: false, error: undefined };
        case CategoryTypes.GET_CATEGORIES_CLEAR:
            return INITIAL_STATE;
        case CategoryTypes.TOGGLE_CATEGORY:
            const { selectedCategories } = state.data;
            const selected: boolean = selectedCategories && !!selectedCategories.find((category: Category) => category.id === action.payload.id);

            const updatedCategories: Category[] = selected
                ? selectedCategories && selectedCategories.filter((category: Category) => category.id !== action.payload.id)
                : [...selectedCategories, action.payload];

            return { ...state, data: { ...state.data, selectedCategories: updatedCategories } };
        case CategoryTypes.SET_SELECTED_CATEGORIES:
            return { ...state, data: { ...state.data, selectedCategories: action.payload } };
        default:
            return state;
    }
};

export default reducer;
